import OrderDetail from "features/order-detail/containers/OrderDetails";
import React from "react";

const OrderDetailComponent = () => {
  return <OrderDetail />;
};

export default OrderDetailComponent;
